import { render } from "./ModelItem.vue?vue&type=template&id=ea07ec40"
import script from "./ModelItem.vue?vue&type=script&lang=js"
export * from "./ModelItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__